import { FilterVariant, IFilterItem } from "@next-platform/client-common-spicy-ui";

export const getTranslatedTagLabel = (tagName: string, translateTag: (tag: string) => string) => {
  return translateTag(tagName);
};

export function getTagsList({
  selectedTagsSearchClient,
  allowedTags,
  tagItems,
  translateTag,
}: {
  selectedTagsSearchClient: string[];
  allowedTags: string[];
  tagItems: { label: string; value: string; count: number; isRefined: boolean }[];
  translateTag: (tag: string) => string;
}) {
  const isTagListEmpty = !tagItems?.length;
  const includedTags: IFilterItem[] = [];
  const excludedTags: IFilterItem[] = [];
  const remainingTags: IFilterItem[] = [];

  selectedTagsSearchClient?.forEach((tag) => {
    if (tag?.startsWith("-")) {
      if (!allowedTags?.includes(tag.substring(1))) {
        return;
      }

      return excludedTags.push({
        label: translateTag(tag.substring(1)),
        value: tag.substring(1),
        count: null,
        variant: FilterVariant.EXCLUDE,
      });
    }

    if (!allowedTags?.includes(tag)) {
      return;
    }

    if (isTagListEmpty) {
      includedTags.push({
        label: translateTag(tag),
        value: tag,
        count: null,
        variant: FilterVariant.INCLUDE,
      });
    }
  });

  if (!isTagListEmpty) {
    tagItems?.forEach((tag) => {
      if (!allowedTags?.includes(tag?.value)) {
        return;
      }

      const tagData = {
        label: translateTag(tag.value),
        value: tag.value,
        count: tag.count,
        variant: selectedTagsSearchClient?.includes(tag.value) ? FilterVariant.INCLUDE : FilterVariant.DEFAULT,
      };

      if (tag?.isRefined) {
        includedTags.push(tagData);
      } else if (!selectedTagsSearchClient?.includes(`-${tag?.value}`)) {
        remainingTags.push(tagData);
      }
    });
  }

  return [...includedTags, ...excludedTags, ...remainingTags];
}
